// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29eaI","toggleWrap":"styles_toggleWrap__2muTJ","content":"styles_content__2sPLn","selectAreaCode":"styles_selectAreaCode__ts4-T"};